import {createFeatureSelector, createSelector} from '@ngrx/store';
import {CisternState, FEATURE_NAME} from './cistern.state';

export const selectCisternState = createFeatureSelector<CisternState>(FEATURE_NAME);

export const selectFilteredCisternsWithCurrentPage = createSelector(
  selectCisternState,
  (state: CisternState) => {
    if (state.filter?.page === null
      || state.filter?.page === undefined
      || !state.pages[state.filter!!.page!!]) {
      return [];
    }

    return state.pages[state.filter!!.page!!]
      .map((id) => state.entities[id]) ?? []
  }
);

export const selectIsCisternsLoading = createSelector(
  selectCisternState,
  (state) => state.isLoading
);

export const selectCisternError = createSelector(
  selectCisternState,
  (state) => state.error
);

export const selectCisternFilter = createSelector(
  selectCisternState,
  (state) => state.filter
);

export const selectCisternsTotalCount = createSelector(
  selectCisternState,
  (state) => state.totalCount
);

export const selectCisternById = (id: string) => createSelector(
  selectCisternState,
  (state: CisternState) => state.entities.hasOwnProperty(id)
    ? state.entities[id]
    : null
);

export const selectAllCisterns = createSelector(
  selectCisternState,
  (state: CisternState) => Object.values(state.entities)
);

export const selectCisternBySensorId = (id: string) => createSelector(
  selectCisternState,
  (state: CisternState) => Object.values(state.entities)
    .find((entity) => entity.distanceSensor?.id === id),
);
